webpackJsonp([75205924225882],{

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/header-noplay.4b2ef59a.png";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-41.1d98689e.jpg";

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _img = __webpack_require__(467);
	
	var _img2 = _interopRequireDefault(_img);
	
	var _headerNoplay = __webpack_require__(464);
	
	var _headerNoplay2 = _interopRequireDefault(_headerNoplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Writers = function Writers() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      {
	        className: 'slice-lg slice--offset-top bg-base-1',
	        style: {
	          background: 'url(' + _img2.default + ')',
	          backgroundRepeat: 'repeat'
	        }
	      },
	      _react2.default.createElement('span', { className: 'mask mask-base-1--style-2' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container sct-inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-7 col-lg-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'py-5 text-center text-md-left' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'heading heading-1 c-white strong-400 text-normal' },
	                'Join our network, and write for us!'
	              ),
	              _react2.default.createElement('span', { className: 'clearfix' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'lead strong-300 c-white mt-4' },
	                'Apply for our freelancer bootcamp.'
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.ondelta.io/',
	                  className: 'btn btn-styled btn-white btn-circle mt-4',
	                  'data-fancybox': true
	                },
	                _react2.default.createElement('i', { className: 'fa fa-play' }),
	                ' Click to Start Your Application'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'slice-lg sct-color-1 border-bottom' },
	      _react2.default.createElement(
	        'div',
	        { className: 'spotlight-top' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center cols-xs-space cols-sm-space cols-md-space' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6 order-lg-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'relative' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'spotlight-floating-img align-right' },
	                  _react2.default.createElement('img', {
	                    src: _headerNoplay2.default,
	                    style: { width: '600px' },
	                    className: 'block-image'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-5 ml-lg-auto order-lg-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'py-3 pr-5' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'heading heading-xs text-uppercase strong-600 c-base-1 ls-1' },
	                  '01. Welcome'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'section-title section-title--style-1' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'section-title-inner heading-3 text-normal strong-500' },
	                    'Join Our Highly Curated Writer Network.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'mt-2 line-height-1_8' },
	                  'Take our copywriting course, and join our freelancer network.',
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  'Writing for us gives you the opportunity to make money from the comfort of your own home. You choose your earning potential. ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    'You must be at least 18 years of age to apply for our program.'
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://www.ondelta.io/',
	                      className: 'btn btn-styled btn-dark btn-circle mt-4',
	                      'data-fancybox': true
	                    },
	                    _react2.default.createElement('i', { className: 'fa fa-play' }),
	                    ' Click to start your application'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'slice-lg sct-color-2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'heading heading-xs text-uppercase text-center strong-600 c-base-1 ls-2' },
	          '02. Our Perks'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section-title section-title--style-1 text-center mb-2' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-title-inner heading-3 text-normal strong-500' },
	            'Why Write For Us?'
	          )
	        ),
	        _react2.default.createElement('span', { className: 'clearfix' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'fluid-paragraph fluid-paragraph-xs c-gray-light strong-300 text-center' },
	          'Here are a few reasons why you should work with us.'
	        ),
	        _react2.default.createElement('span', { className: 'space-xs-xl' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row cols-xs-space cols-md-space cols-lg-space' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-block icon-block--style-1-v5 text-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'block-icon c-base-2' },
	                _react2.default.createElement('i', { className: 'fa fa-graduation-cap' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'block-content' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'heading heading-6 strong-500 c-base-1' },
	                  'Training'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'px-3' },
	                  'Learn how to become one of the top freelance writers in the industry. We teach you not only how to be a great writer, but also the best practices for being an independent contractor.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-block icon-block--style-1-v5 text-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'block-icon c-base-2' },
	                _react2.default.createElement('i', { className: 'fa fa-university' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'block-content' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'heading heading-6 strong-500 c-base-1' },
	                  'Competitve Rates'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'px-3' },
	                  'Make a competitive freelance writing salary. Writing for us gives you the opportunity to make money doing what you love, from the comfort of your own home.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon-block icon-block--style-1-v5 text-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'block-icon c-base-2' },
	                _react2.default.createElement('i', { className: 'fa fa-calendar' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'block-content' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'heading heading-6 strong-500 c-base-1' },
	                  'Extended Contracts'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'px-3' },
	                  'Instead of waiting for the next gig, we pair you with clients that we feel are the best match for you. Once you join a client\'s team, you are with that team for the term of their contract.'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'slice border-top border-bottom' },
	      _react2.default.createElement('span', { className: 'space-xs-lg' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'heading heading-xs text-uppercase strong-600 c-base-1 ls-2' },
	          '03. Our Hiring Process'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section-title section-title--style-1 mb-2' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'section-title-inner heading-3 text-normal strong-500' },
	            'Do You Have What It Takes?'
	          )
	        ),
	        _react2.default.createElement('span', { className: 'clearfix' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-gray-light strong-300' },
	          'We don\'t let just anyone join our writing program. We strive to create a community of writers that have the drive and ambition to be the best. ',
	          _react2.default.createElement('br', null),
	          ' Our application and onboarding process is for vetting and ensuring that the writers we hire are the right fit for our community.'
	        ),
	        _react2.default.createElement('span', { className: 'delimiter delimiter--style-1 mt-5 mb-5' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'heading heading-xs text-uppercase strong-600 c-base-1 ls-2' },
	            'Our Application Process'
	          ),
	          _react2.default.createElement('span', { className: 'space-xs-md' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row cols-xs-space cols-sm-space cols-md-space' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icon-block icon-block--style-1-v5 px-4' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block-icon c-base-2' },
	                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block-content' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600 text-capitalize' },
	                    '1. Take Our Writing Exam'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'This is a 30-minute timed exam. This exam includes a questionnaire about your prior work experience and writing prompts to gauge your writing skills.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icon-block icon-block--style-1-v5 px-4' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block-icon c-base-2' },
	                  _react2.default.createElement('i', { className: 'fa fa-graduation-cap' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block-content' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600 text-capitalize' },
	                    '2. Freelancer Bootcamp'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'If you\'re accepted, you\'ll select your start day and take our freelancer course. The course focuses on building your remote work and writing skills. It helps us set the standards and expectations for our writers.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-lg-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'icon-block icon-block--style-1-v5 px-4' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block-icon c-base-2' },
	                  _react2.default.createElement('i', { className: 'fa fa-users' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'block-content' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600 text-capitalize' },
	                    '3. Join the Community'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'If you make it through our bootcamp, we\'ll match you with a team based on YOUR preferences.'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('span', { className: 'space-xs-lg' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'slice sct-color-1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row cols-md-space cols-sm-space cols-xs-space' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-5' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'heading heading-xs text-uppercase strong-600 c-base-1 ls-2' },
	              '04. Frequently Asked Questions'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'heading heading-3 strong-300 text-capitalize' },
	              'Questions About Our Hiring Process'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-7' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'feature feature--text-only bg-transparent' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600' },
	                    'Are your writers contractors or employees?'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'All of our writers are contractors.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'feature feature--text-only bg-transparent mt-5' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600' },
	                    'Where do we take the course?'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'The course is completely online. If you are accepted to take the course, you will be able to choose the time slot you start the course.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'feature feature--text-only bg-transparent mt-5' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600' },
	                    'Does everyone who finishes the course get a writing job?'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'We only accept writers into our program if there\'s work for them to do, we do our best to place everyone but, jobs are not guaranteed.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'feature feature--text-only bg-transparent' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600' },
	                    'What are the qualifications for being a Jamocha writer?'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'A writer applying to work for Jamocha should have a strong background in English composition. You must also be over the age of 18 years old to apply. Prior experience is also helpful, but not a sole factor in our decision process.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'feature feature--text-only bg-transparent mt-5' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'heading heading-6 strong-600' },
	                    'Payment schedule and amount?'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Writers are paid on the 15th of every month. We pay between $0.75-$1.25/word.'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      {
	        className: 'slice-sm bg-base-1',
	        style: {
	          background: 'url(' + _img2.default + ')',
	          backgroundRepeat: 'repeat'
	        }
	      },
	      _react2.default.createElement('span', { className: 'mask mask-base-1--style-2' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container sct-inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center cols-md-space cols-sm-space cols-xs-space' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-9' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center text-md-left' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'heading heading-inverse heading-4 text-normal strong-500' },
	                'Change Your Life Today! Apply to Be A Writer.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-center text-lg-right' },
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.ondelta.io/',
	                  className: 'btn btn-styled btn-white btn-circle mt-4',
	                  'data-fancybox': true
	                },
	                _react2.default.createElement('i', { className: 'fa fa-play' }),
	                ' Click to Start Your Application'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Writers;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-writers-js-b1e8fa977f2a2b3d894b.js